// extracted by mini-css-extract-plugin
var _1 = "webpack-components-FileUploadDialog-components-DragAndDropFileUploader-module__errorMessage";
export { _1 as "errorMessage" }
